export const SITE_BOUNDARY_COLORS = [
  '#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#A133FF',
  '#33FFA1', '#FF7F50', '#6A5ACD', '#20B2AA', '#DB7093',
  '#FFD700', '#ADFF2F', '#00BFFF', '#FF69B4', '#BA55D3',
  '#00FA9A', '#FF4500', '#483D8B', '#5F9EA0', '#C71585',
  '#F9E79F', '#5DADE2', '#A9DFBF', '#F5B7B1', '#D7BDE2',
  '#E59866', '#85C1E9', '#FAD7A0', '#B2BABB', '#A3E4D7'
];

export const getColorByIndex = (index: number): string => {
  return SITE_BOUNDARY_COLORS[index % SITE_BOUNDARY_COLORS.length];
};